// src/tiptap/diff/normalizeForSave.js
// Assign stable IDs to all diffable containers (blocks, lists, tables).
// Never assign ids to inline nodes (text, image). Run before persisting to DB.

import { v4 as uuidv4 } from 'uuid'

export function normalizeForSave(doc) {
  if (!doc || typeof doc !== 'object') return doc

  // Must match the node types enabled to carry `id` in GlobalIds
  // and align with the canonical backend renderer container logic.
  const CONTAINER_TYPES_FOR_IDS = new Set([
    // text-bearing blocks
    'paragraph',
    'heading',
    'blockquote',
    // lists
    'bulletList',
    'orderedList',
    'listItem',
    // tables
    'table',
    'tableRow',
    'tableCell',
    'tableHeader',
    // embeds
    'video',
  ])

  const out = JSON.parse(JSON.stringify(doc))
  const seen = new Set()

  function visit(node) {
    if (!node || typeof node !== 'object') return

    const t = node.type
    if (CONTAINER_TYPES_FOR_IDS.has(t)) {
      node.attrs ??= {}
      let id = node.attrs.id
      // Assign or repair duplicates
      if (!id || seen.has(id)) {
        id = uuidv4()
        node.attrs.id = id
      }
      seen.add(id)
    }

    if (Array.isArray(node.content)) {
      for (const child of node.content) visit(child)
    }
  }

  visit(out)
  return out
}
